import { render, staticRenderFns } from "./TaskMatchExpressionsCard.vue?vue&type=template&id=4bb4332a&scoped=true&"
import script from "./TaskMatchExpressionsCard.vue?vue&type=script&lang=ts&"
export * from "./TaskMatchExpressionsCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskMatchExpressionsCard.vue?vue&type=style&index=0&id=4bb4332a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4332a",
  null
  
)

export default component.exports